import type { RouteKey } from '@/router/routesPathConfig';
import type { CompanyWorkspaceDestinationKey } from '@/abilities/companyWorkspace/vocabulary';

/** The route that shows each place of the company workspace. */
export const companyWorkspaceDestinationRoutes: Record<CompanyWorkspaceDestinationKey, RouteKey> = {
  standard: 'COMPANY_WORKSPACE',
  confidential: 'COMPANY_CONFIDENTIAL_WORKSPACE',
};
